import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDate } from '../../../../utils/fmt';

const QuotePaymentListDetails = () => {
  const columns = [
    { label: 'Quote', value: 'quote' },
    { label: 'Amount', value: 'amount' },
    { label: 'Payment Date', value: (item) => fmtDate(item.payment_date) },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/quote/payment/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['quotePayment']} />;
};

export default QuotePaymentListDetails;